import React, { Component } from 'react';

import './AnimatedLayer.scss';

class AnimatedLayer extends Component {

	constructor() {
        super();
	}

    componentDidMount() {
    }

    componentWillUnount() {
    }

	render() {
		var classItem = [
			'animated_layer',
		];

        var layerStyles = { 
            left: this.props.x,
            top: this.props.y,
            width: this.props.width
        };

        return (
        	<div className={ classItem.join(' ') } data-depth={ this.props.depth }>
                <img src={ this.props.image } style={ layerStyles } />
            </div>
    	);
	}
}

export { AnimatedLayer };